import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'shrd-pf-ui-meta-nav-item',
  template: '<ng-content></ng-content>',
  styleUrls: ['./meta-nav-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class MetaNavItemComponent {}
